import { Image } from '@react-three/drei'
export default function Panel({ size, ...props }) {
  return (
    <Image url={`./textures/transparent-grey.jpg`} transparent opacity={0.7} radius={0.1} {...props}>
      <planeGeometry args={[size[0], size[1], 20, 20]} />
    </Image>
  )
}
